import { render, staticRenderFns } from "./BidsFinesPage.vue?vue&type=template&id=d446bbc4"
import script from "./BidsFinesPage.vue?vue&type=script&lang=js"
export * from "./BidsFinesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports